module.exports = __webpack_public_path__ + "static/media/play-white.e0ac2159.svg";